var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLayoutBanner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 814,
    height: 458,
    viewBox: "0 0 814 458",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 814,
    height: 458,
    fill: "#B9BFC2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 23,
    width: 755,
    height: 435,
    fill: "#D5D8DA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 33,
    width: 125,
    height: 125,
    fill: "#B3D7EC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 33,
    width: 155,
    height: 415,
    fill: "#F3F5F5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 650,
    y: 178,
    width: 125,
    height: 125,
    fill: "#004B9E"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 505,
    y: 323,
    width: 270,
    height: 125,
    fill: "#007BC1"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 33,
    width: 415,
    height: 125,
    fill: "#80BDE0"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 178,
    width: 280,
    height: 270,
    fill: "#268FCA"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 505,
    y: 178,
    width: 125,
    height: 125,
    fill: "#4DA3D4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayoutBanner);
export default __webpack_public_path__ + "static/media/layout-banner.2edeef297dc715f1325da0b4d428ffaf.svg";
export { ForwardRef as ReactComponent };